/* =====================================================================
 * TSG Results Stats — on-scroll animation
 * Uses IntersectionObserver to animate progress bars from 0 → target%
 * when section first enters viewport. Respects prefers-reduced-motion.
 * ===================================================================== */

(function () {
  'use strict';

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function animateBars(root) {
    const fills = root.querySelectorAll('[data-tsg-target]');
    fills.forEach((fill) => {
      const pct = parseFloat(fill.dataset.tsgTarget || '0');
      if (prefersReduced) {
        fill.style.width = pct + '%';
      } else {
        // Defer one frame so the transition kicks in
        requestAnimationFrame(() => {
          fill.style.width = pct + '%';
        });
      }
    });
  }

  function initResults(root) {
    if (!('IntersectionObserver' in window)) {
      animateBars(root);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateBars(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.25 });

    observer.observe(root);
  }

  function initAll() {
    document.querySelectorAll('[data-tsg-results]').forEach(initResults);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-tsg-results]');
    if (root) initResults(root);
  });
})();
